type InstagramLoaderProps = {
  label?: string;
  className?: string;
  loaderClassName?: string;
};

export const InstagramLoader = ({
  label = "Loading...",
  className = "",
  loaderClassName = "",
}: InstagramLoaderProps) => (
  <div className={`w-full flex justify-center ${className}`.trim()}>
    <div className={`instagram-loader ${loaderClassName}`.trim()} aria-label={label} />
  </div>
);

